import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./mycreatedpolls.scss";
import axios from "axios";
import { api_url } from "../../utils/Enviroment";
// import { useWeb3React } from "@web3-react/core";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../RecoilAtom";
import { formatNumbers, convertFromWei } from "../../utils/helpers";
import { getOpenInterest, getUserLivePoolsCount, getUsersInvestment } from "../../utils/services";
import MyPredictedMarkets from "./MyPredictedMarkets";
import { useEoaAccount } from "../../hooks/useEoaAccount";

const MyPrediction = () => {
    const { t } = useTranslation();
    const { account } = useEoaAccount();
    const [activeKey, setActiveKey] = useState("Investment Polls");
    const [totalInvestments, setTotalInvestments] = useState("");
    const [totalpnl, setTotalPnl] = useState([]);
    const [openInterest, setOpenInterest] = useState("");
    const accessToken = localStorage.getItem("accessToken");
    const smartAccount = useRecoilValue(userSmartAccount);
    const [livePoolsCount, setLivePoolsCount] = useState(0)

    useEffect(() => {
        if (account && smartAccount && accessToken) {
            (async () => {
                await getTotalPnl()
            })();
        }
    }, [account, smartAccount, accessToken]);

    const handleSelect = (key) => {
        setActiveKey(key);
    };

    const getTotalPnl = async () => {
        try {
            const response = await axios.get(
                `${api_url}/investments/calculate-user-PNL`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            const data = response?.data?.data;
            const convertedData = {
                totalInvestment: convertFromWei(data.totalInvestment),
                totalClaimed: convertFromWei(data.totalClaimed),
                pnl: convertFromWei(data.pnl),
            };
            setTotalPnl(convertedData);
        } catch (error) {
            console.error("Error fetching PNL data:", error);
        }
    };

    useEffect(() => {
        ((async () => {
            try {
                const responseUserTotalInvestment = await getUsersInvestment();
                const userTotalInvestment = convertFromWei(responseUserTotalInvestment?.data?.details?.totalInvestment, "mwei")
                setTotalInvestments(userTotalInvestment || 0);
            } catch (error) {
                console.log("error in getting Total Investments:", error);
            }
        }))()
    }, []);

    const getOpenInterestData = async () => {
        const interestRes = await getOpenInterest()
        const convertedFromWeiInterest = convertFromWei(interestRes?.totalOpenInterest, "mwei")
        setOpenInterest(convertedFromWeiInterest)
    }

    useEffect(() => {
        const fetchData = async () => {
            const userLivePoolsCount = await getUserLivePoolsCount();
            setLivePoolsCount(userLivePoolsCount);
        };
        fetchData();
        getOpenInterestData()
    }, []);

    return (
        <>
            <section className="mycreatedpolls mypredictionssection">
                <div className="custom-container">
                    <div className="main-heading">
                        <h4>{t("My Predictions")}</h4>
                    </div>
                    <div className="bottom-twice-inline">
                        <div className="text">
                            <p>{t("Open Interest")} </p>
                            <h6>${openInterest ? formatNumbers(+openInterest) : "0"}</h6>
                        </div>
                        <div className="text">
                            <p>{t("Live Markets")} </p>
                            <h6>{livePoolsCount}</h6>
                        </div>
                        <div className="text">
                            <p>{t("Total Invested")} </p>
                            <h6>{totalInvestments ? `$${formatNumbers(+totalInvestments)}` : "0"}</h6>
                        </div>
                        <div className="text">
                            <p>{t("Total PnL")} </p>
                            <h6 style={{ color: totalpnl?.pnl >= 0 ? "var(--green-text)" : "var(--logout-text)", margin: "0" }}>{totalpnl?.pnl ? `$${formatNumbers(+totalpnl?.pnl)}` : "0"}</h6>
                        </div>
                    </div>
                    <div className="tabsmain">
                        <Tabs
                            onSelect={handleSelect}
                            id="controlled-tab-example"
                            activeKey={activeKey}
                            className="bannertabs"
                        >
                            <Tab eventKey="Investment Polls" title={t("My Predictions")}>
                                <MyPredictedMarkets
                                    activeKey={activeKey}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </section>


        </>
    );
};

export default MyPrediction;


